export default __webpack_public_path__ + "static/media/arrow-down.a3ef229e.svg";